import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { api } from "@/lib/api";
import { PageShell } from "@/components/Shell";

const MSG = {
  Approved: ["Identità verificata con successo. Il tuo profilo è ora in attesa di approvazione da parte dell'amministratore.", "ok"],
  Declined: ["La verifica non è andata a buon fine. Puoi riprovare dal tuo profilo.", "ko"],
  Abandoned: ["La verifica è stata interrotta. Puoi riprenderla dal tuo profilo.", "ko"],
  Expired: ["La sessione di verifica è scaduta. Puoi avviarne una nuova dal tuo profilo.", "ko"],
};

export default function DiditResultPage() {
  const [status, setStatus] = useState(null);
  useEffect(() => {
    let n = 0;
    const tick = () => api.get("/identity/didit/status").then(({ data }) => {
      setStatus(data.status);
      n += 1;
      if (!MSG[data.status] && n < 30) setTimeout(tick, 4000);
    }).catch(() => setStatus("error"));
    tick();
  }, []);
  const [text, kind] = MSG[status] || ["Stiamo ricevendo l'esito della verifica da Didit…", "wait"];
  return (
    <PageShell title="Verifica identità" subtitle="Esito della verifica con Didit" testid="didit-result-page">
      <div className="glass max-w-xl space-y-4 rounded-3xl p-6" data-testid="didit-result">
        <p className="flex items-start gap-2 text-sm text-slate-700">
          {kind === "ok" ? <CheckCircle2 className="h-5 w-5 shrink-0 text-emerald-600" /> : kind === "ko" ? <XCircle className="h-5 w-5 shrink-0 text-rose-600" /> : <Loader2 className="h-5 w-5 shrink-0 animate-spin text-emerald-600" />}
          <span data-testid="didit-result-text">{status === "error" ? "Impossibile leggere l'esito. Riprova dal profilo." : text}</span>
        </p>
        <div className="flex gap-2">
          <Link to="/profilo?tab=certificazione" data-testid="didit-result-profile" className="rounded-full bg-emerald-600 px-4 py-2 text-xs font-bold text-white hover:bg-emerald-700">Vai al profilo</Link>
          <Link to="/" className="rounded-full border border-slate-300 px-4 py-2 text-xs font-bold text-slate-700">Torna alla clinica</Link>
        </div>
      </div>
    </PageShell>
  );
}
